(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Shift', Shift);

    Shift.$inject = ['$resource', 'DateUtils'];

    function Shift ($resource, DateUtils) {
        var resourceUrl =  'api/shifts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCreated = DateUtils.convertDateTimeFromServer(data.dateCreated);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'sign': {url: 'api/shifts/sign', method: 'PUT'},
            'findAllByFilter': {url: 'api/shifts/filter', method: 'GET', isArray: true}
        });
    }
})();
